import AppRouter from 'common/AppRouter';
import {
  SESSION_STORAGE_KEYS,
  VIEW_PATH_KEYS
} from 'common/constants/constants';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';

export const mapViewPathToSessionKey = viewPath => {
  const viewPathInAppRouter = `/${viewPath}`;

  switch (viewPathInAppRouter) {
    case AppRouter.ROOT.path:
      return VIEW_PATH_KEYS.DASHBOARD;
    case AppRouter.PAGE_DASHBOARD.path:
      return VIEW_PATH_KEYS.DASHBOARD;
    case AppRouter.TEAM_GOALS.path:
      return VIEW_PATH_KEYS.TEAM_GOALS;
    case AppRouter.CONTRIBUTORS.path:
      return VIEW_PATH_KEYS.CONTRIBUTORS;
    default:
      return VIEW_PATH_KEYS.DASHBOARD;
  }
};

const defaultValue = true;

/**
 * Gets the filter status by Git scope.
 * @param {object} gitScopeToggle - The toggle object containing filter statuses.
 * @param {string} sessionKey - The session key to get the filter status for.
 * @returns {boolean} - The filter status.
 */
export const getIsGitScopeByKey = (gitScopeToggle, sessionKey) => {
  return gitScopeToggle?.[sessionKey] ?? defaultValue;
};

/**
 * Gets the filter status by Git scope.
 * @param {string} sessionKey - The page to get the filter status for.
 * @returns {boolean} - The filter status.
 */
export const getIsFilterByGitScope = sessionKey => {
  const defaultSessionKey =
    sessionKey === '' ? VIEW_PATH_KEYS.DASHBOARD : sessionKey;

  if (
    !defaultSessionKey ||
    !SESSION_STORAGE_KEYS.GIT_SCOPE_FILTER[defaultSessionKey]
  ) {
    return defaultValue;
  }

  const gitScopeFilterByPage =
    BrowserStorageAccessor().session.get(
      SESSION_STORAGE_KEYS.GIT_SCOPE_FILTER[defaultSessionKey]
    ) || defaultValue;

  const gitScopeFiltered = JSON.parse(gitScopeFilterByPage);

  return gitScopeFiltered;
};

/**
 * Sets the filter by Git scope.
 * @param {string} sessionKey - The page to set the filter for.
 * @param {boolean} value - The value to set for the filter.
 */
export const setFilterByGitScope = (sessionKey, value = true) => {
  const defaultSessionKey =
    sessionKey === '' ? VIEW_PATH_KEYS.DASHBOARD : sessionKey;
  BrowserStorageAccessor().session.set(
    SESSION_STORAGE_KEYS.GIT_SCOPE_FILTER[defaultSessionKey],
    value
  );
};
